<ng-container matColumnDef [sticky]="sticky" [stickyEnd]="stickyEnd">
  <mat-header-cell *matHeaderCellDef [mat-sort-header]="sortId || name" [disabled]="nonSortable" [class.g-table-column-checkbox]="checkbox"
    >{{ label || 'FIELDS.' + (fieldsRewrite[name] || name) | translate }}{{ currencyColumn ? ', ' + currency + (literFraction ? '/l' : '') :
    ''}}</mat-header-cell
  >
  <mat-cell *matCellDef="let data" [class.g-table-column-checkbox]="checkbox">
    <ng-template *ngTemplateOutlet="templateRef; context: { $implicit: data }"></ng-template>
  </mat-cell>
  <mat-footer-cell *matFooterCellDef>{{ footerContent }}</mat-footer-cell>
</ng-container>
